import React, { useState, useEffect } from "react";
import PageHeading from "../../components/PageHeading";
import { BackButton } from "../../components/btn/Buttons";
import Dropdown from "../../components/inputs/Dropdown";
import "./FinacialReports.css";
import Table from "../../components/table/Table";
import { base_url, getFinancialYearOptions } from "../../utils/utils";
import SmallModal from "../../components/modal/SmallModal";
import { useSelector } from "react-redux";
import Input from "../../components/inputs/Input";

const ProAndLoss = () => {
  // State for storing the selected financial year
  const [financialYear, setFinancialYear] = useState("");
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState("Select a year");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [alerts, setAlerts] = useState(false);
  const [alerts2, setAlerts2] = useState(false);
  const [opening_balance, setOpening_balance] = useState("");
  const [alertsMess, setAlertsMess] = useState("");
  const { profile_data } = useSelector((state) => state.profile);
  // Get agency ID from localStorage
  const getAgencyId = () => {
    const userIdString = localStorage.getItem("userId");
    if (userIdString) {
      const userData = JSON.parse(userIdString);
      return userData?.aid;
    }
    return null;
  };

  // Fetch P&L report data from API
  const fetchProfitLossReport = async (fy) => {
    try {
      setLoading(true);
      const agencyId = getAgencyId();

      if (!agencyId) {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "red", textAlign: "left" }}>
            <p>Error: Agency ID not found</p>
          </div>
        );
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("action", "list");
      formData.append("agencyid", agencyId);
      formData.append("FY", fy);

      const response = await fetch(
        `${base_url}financial_reports/profit_loss_report.php`,
        { method: "POST", body: formData }
      );

      const result = await response.json();

      if (result.success && result.data) {
        // Handle array response structure
        const reportDataArray = Array.isArray(result.data)
          ? result.data
          : [result.data];
        const reportDataItem = reportDataArray[0];

        if (reportDataItem) {
          setReportData(reportDataItem);
          setStatus("Completed");
          setOpen(true);
        } else {
          setAlerts(true);
          setAlertsMess(
            <div style={{ color: "red", textAlign: "left" }}>
              <p>No data found for the selected financial year</p>
            </div>
          );
          setStatus("Error");
        }
      } else {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "red", textAlign: "left" }}>
            <p>{result.message || "Error fetching P&L report data"}</p>
          </div>
        );
        setStatus("Error");
      }
    } catch (error) {
      console.error("Error fetching P&L report:", error);
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "red", textAlign: "left" }}>
          <p>Error: {error.message}</p>
        </div>
      );
      setStatus("Error");
    } finally {
      setLoading(false);
    }
  };

  // Handler for when the financial year changes
  const handleYearChange = (event) => {
    setFinancialYear(event.target.value);
    setStatus("Select a year");
  };

  // Handler for FETCH button
  const handleFetch = () => {
    if (!profile_data?.OPENING_BALANCE) {
      setAlerts2(true);

      return;
    }
    if (!financialYear) {
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "orange", textAlign: "left" }}>
          <p>Please select a financial year first</p>
        </div>
      );
      return;
    }
    fetchProfitLossReport(financialYear);
  };

  // Calculate values from API data
  const getCalculations = () => {
    if (!reportData) return {};

    // Extract nested purchase object
    const purchaseData = reportData.purchase || {};
    const salesData = reportData.sales || {};
    const totalsData = reportData.totals || {};
    const indirectExpensesData = reportData.indirect_expenses || {};

    const tradingDebitTotal =
      parseFloat(
        totalsData.TOTAL_TRADING_DEBIT_VALUE ||
          reportData.TOTAL_TRADING_DEBIT_VALUE
      ) || 0;
    const tradingCreditTotal =
      parseFloat(
        totalsData.TOTAL_TRADING_CREDIT_VALUE ||
          reportData.TOTAL_TRADING_CREDIT_VALUE
      ) || 0;
    const grossProfit =
      parseFloat(
        totalsData.TOTAL_GROSS_PROFIT || reportData.TOTAL_GROSS_PROFIT
      ) || 0;

    const expenseDebit =
      parseFloat(
        totalsData.TOTAL_EXPENSE_DEBIT || reportData.TOTAL_EXPENSE_DEBIT
      ) || 0;
    const expenseCredit =
      parseFloat(
        totalsData.TOTAL_EXPENSE_CREDIT || reportData.TOTAL_EXPENSE_CREDIT
      ) || 0;
    const netProfit =
      parseFloat(totalsData.TOTAL_NET_PROFIT || reportData.TOTAL_NET_PROFIT) ||
      0;

    const grandTotal1 = parseFloat(reportData.GRAND_TOTAL1) || 0;
    const grandTotal2 = parseFloat(reportData.GRAND_TOTAL2) || 0;

    return {
      purchaseData,
      salesData,
      indirectExpensesData,
      tradingDebitTotal,
      tradingCreditTotal,
      grossProfit,
      expenseDebit,
      expenseCredit,
      netProfit,
      grandTotal1,
      grandTotal2,
    };
  };

  const handleUpdateBalance = async () => {
    try {
      setLoading(true);
      const agencyId = getAgencyId();

      const formData = new FormData();
      formData.append("action", "update_opening_balance");
      formData.append("agencyid", agencyId);
      formData.append("opening_balance", opening_balance);

      const response = await fetch(
        `${base_url}financial_reports/profit_loss_report.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result.success) {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "green", textAlign: "left" }}>
            <p>{result.message || "Partner data saved successfully!"}</p>
          </div>
        );
        return true;
      } else {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "red", textAlign: "left" }}>
            <p>{result.message || "Error saving partner data"}</p>
          </div>
        );
        return false;
      }
    } catch (error) {
      console.error("Error submitting partner data:", error);
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "red", textAlign: "left" }}>
          <p>Error: {error.message || "Failed to save partner data"}</p>
        </div>
      );
      return false;
    } finally {
      setAlerts2(false);
      setLoading(false);
    }
  };

  const calculations = getCalculations();

  return (
    <div className="container">
      <PageHeading title={"PROFIT AND LOSS ACCOUNT"} right={<BackButton />} />
      <div style={{ height: "20px" }}></div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "flex-end",
          gap: 20,
        }}
      >
        <div style={{ width: "180px" }}>
          <Dropdown
            label={"FINANCIAL YEAR"}
            value={financialYear}
            onChange={handleYearChange}
            options={
              <>
                <option value="">SELECT</option>
                {getFinancialYearOptions(profile_data?.CREATED_DATE)?.map(
                  (v) => (
                    <option value={v}>{v}</option>
                  )
                )}
              </>
            }
          />
        </div>
        <button
          className="GENERATE-BTN"
          onClick={handleFetch}
          disabled={loading}
          style={loading ? { opacity: 0.5, cursor: "not-allowed" } : {}}
        >
          {loading ? "LOADING..." : "FETCH"}
        </button>
      </div>
      <div style={{ height: "20px" }}></div>

      {open && reportData && (
        <>
          <div style={{ marginBottom: "30px" }}>
            <div className="FinacialYear">
              <span
                style={{
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                FINANCIAL YEAR:
              </span>
              <p
                className="FDATE"
                style={{ alignItems: "center", display: "flex" }}
              >
                {financialYear}
              </p>
              <span
                style={{
                  fontSize: "11px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                STATUS :
              </span>
              <p
                className="FDATE"
                style={{ alignItems: "center", display: "flex" }}
              >
                {status}
              </p>
            </div>
          </div>

          {/* TRADING ACCOUNT */}
          <div style={{ marginBottom: "40px" }}>
            <h3
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "#0971fe",
              }}
            >
              TRADING ACCOUNT
            </h3>

            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              {/* OUTWARD TRANSACTIONS */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    color: "#333",
                  }}
                >
                  TO (Outward Transactions - Debits)
                </h4>
                <Table
                  headData={["Description", "Value (₹)"]}
                  body={
                    <>
                      <tr>
                        <td>Opening Balance</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.purchaseData.TOTAL_PURCHASE_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Purchases</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.purchaseData.TOTAL_PURCHASE_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To GST (Input)</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.purchaseData
                              .TOTAL_PURCHASE_GST_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Purchase Return (reduce purchases)</td>
                        <td style={{ textAlign: "right", color: "red" }}>
                          −
                          {parseFloat(
                            calculations.purchaseData
                              .TOTAL_PURCHASE_RETURN_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Debit Note (vendor; extra charge)</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.purchaseData.TOTAL_DEBIT_NOTE_VALUE ||
                              0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Credit Note (vendor; reduction)</td>
                        <td style={{ textAlign: "right", color: "red" }}>
                          −
                          {parseFloat(
                            calculations.purchaseData.TOTAL_CREDIT_NOTE_VALUE ||
                              0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ opacity: 0 }}>.</td>
                        <td style={{ textAlign: "right", color: "red" }}></td>
                      </tr>

                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td>Trading Total (Debit)</td>
                        <td style={{ textAlign: "right" }}>
                          ₹
                          {calculations.tradingDebitTotal.toLocaleString(
                            undefined,
                            { maximumFractionDigits: 2 }
                          )}
                        </td>
                      </tr>
                    </>
                  }
                />
              </div>

              {/* INWARD TRANSACTIONS */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    color: "#333",
                  }}
                >
                  BY (Inward Transactions - Credits)
                </h4>
                <Table
                  headData={["Description", "Value (₹)"]}
                  body={
                    <>
                      <tr>
                        <td>By Sales</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.salesData.TOTAL_SALES_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>By GST (Output)</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.salesData.TOTAL_SALES_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>Less: Sales Return</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.salesData.TOTAL_SALES_GST_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>Sales Debit Note</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.salesData
                              .TOTAL_SALES_DEBIT_NOTE_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>Sales Credit Note</td>
                        <td style={{ textAlign: "right", color: "red" }}>
                          −
                          {parseFloat(
                            calculations.salesData
                              .TOTAL_SALES_CREDIT_NOTE_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>By Gross Profit b/d</td>
                        <td style={{ textAlign: "right" }}>
                          {calculations.grossProfit.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>By Other Income</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.indirectExpensesData
                              .TOTAL_EXPENSE_CREDIT || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td>Trading Total (Credit)</td>
                        <td style={{ textAlign: "right" }}>
                          ₹
                          {calculations.tradingCreditTotal.toLocaleString(
                            undefined,
                            { maximumFractionDigits: 2 }
                          )}
                        </td>
                      </tr>
                    </>
                  }
                />
              </div>
            </div>

            {/* Trading Result */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "30px",
                padding: "15px",
                backgroundColor: "#e8f4f8",
                borderRadius: "5px",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: calculations.grossProfit >= 0 ? "#27ae60" : "#e74c3c",
                }}
              >
                Trading Result (Gross Profit): ₹
                {calculations.grossProfit.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}
              </p>
              {/* <p style={{ fontSize: "12px", color: "#666" }}>
                Formula: (Trading Credit{" "}
                {calculations.tradingCreditTotal.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}{" "}
                − Trading Debit{" "}
                {calculations.tradingDebitTotal.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}
                ) ={" "}
                {calculations.grossProfit.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}
              </p> */}
            </div>
          </div>

          {/* PROFIT & LOSS ACCOUNT */}
          <div style={{ marginBottom: "40px" }}>
            <h3
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "#0971fe",
              }}
            >
              PROFIT & LOSS ACCOUNT (Indirect / Non-trading)
            </h3>

            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              {/* EXPENSES */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    color: "#333",
                  }}
                >
                  TO (Expenses)
                </h4>
                <Table
                  headData={["Description", "Value (₹)"]}
                  body={
                    <>
                      <tr>
                        <td>To Direct Expenses</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.indirectExpensesData
                              .TOTAL_DIRECT_EXPENSE_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Indirect Expenses</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.indirectExpensesData
                              .TOTAL_INDIRECT_EXPENSE_VALUE || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Salaries & Wages</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.indirectExpensesData
                              .TOTAL_SALARY_WAGES || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>To Miscellaneous Expenses</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            calculations.indirectExpensesData
                              .TOTAL_MISCELLENEOUS || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td>Total P&L Debit (Expenses)</td>
                        <td style={{ textAlign: "right" }}>
                          ₹
                          {calculations.expenseDebit.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </>
                  }
                />
              </div>

              {/* INCOMES */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    color: "#333",
                  }}
                >
                  BY (Incomes)
                </h4>
                <Table
                  headData={["Description", "Value (₹)"]}
                  body={
                    <>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td>Total P&L Credit (Incomes)</td>
                        <td style={{ textAlign: "right" }}>
                          ₹
                          {calculations.expenseCredit.toLocaleString(
                            undefined,
                            { maximumFractionDigits: 2 }
                          )}
                        </td>
                      </tr>
                    </>
                  }
                />
              </div>
            </div>

            {/* Net Profit Result */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "30px",
                padding: "15px",
                backgroundColor: "#e8f8f0",
                borderRadius: "5px",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: calculations.netProfit >= 0 ? "#27ae60" : "#e74c3c",
                }}
              >
                Net Profit (to balance): ₹
                {calculations.netProfit.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}
              </p>
              {/* <p style={{ fontSize: "12px", color: "#666" }}>
                Formula: (P&L Credit{" "}
                {calculations.expenseCredit.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}{" "}
                − P&L Debit{" "}
                {calculations.expenseDebit.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}
                ) ={" "}
                {calculations.netProfit.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}
              </p> */}
            </div>
          </div>

          {/* GRAND TOTAL */}
          <div style={{ marginBottom: "30px" }}>
            <h3
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "#0971fe",
              }}
            >
              GRAND TOTAL
            </h3>

            <div style={{ display: "flex", gap: "30px" }}>
              {/* LEFT SIDE */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    color: "#333",
                  }}
                >
                  LEFT SIDE (Debit)
                </h4>
                <Table
                  headData={["Description", "Value (₹)"]}
                  body={
                    <>
                      <tr>
                        <td>Trading Debit</td>
                        <td style={{ textAlign: "right" }}>
                          {calculations.tradingDebitTotal.toLocaleString(
                            undefined,
                            { maximumFractionDigits: 2 }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>P&L Debit</td>
                        <td style={{ textAlign: "right" }}>
                          {calculations.expenseDebit.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>Net Profit (to Balance)</td>
                        <td
                          style={{
                            textAlign: "right",
                            color: "#27ae60",
                            fontWeight: "bold",
                          }}
                        >
                          {calculations.netProfit.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        <td>GRAND TOTAL (Left)</td>
                        <td style={{ textAlign: "right" }}>
                          ₹
                          {calculations.grandTotal1.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </>
                  }
                />
              </div>

              {/* RIGHT SIDE */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    color: "#333",
                  }}
                >
                  RIGHT SIDE (Credit)
                </h4>
                <Table
                  headData={["Description", "Value (₹)"]}
                  body={
                    <>
                      <tr>
                        <td>Trading Credit</td>
                        <td style={{ textAlign: "right" }}>
                          {calculations.tradingCreditTotal.toLocaleString(
                            undefined,
                            { maximumFractionDigits: 2 }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>P&L Credit</td>
                        <td style={{ textAlign: "right" }}>
                          {calculations.expenseCredit.toLocaleString(
                            undefined,
                            { maximumFractionDigits: 2 }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Less: Net Profit</td>
                        <td style={{ textAlign: "right", color: "#e74c3c" }}>
                          −
                          {calculations.netProfit.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        <td>GRAND TOTAL (Right)</td>
                        <td style={{ textAlign: "right" }}>
                          ₹
                          {calculations.grandTotal2.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </>
                  }
                />
              </div>
            </div>
          </div>
        </>
      )}

      <div style={{ height: "20px" }}></div>
      {alerts2 && (
        <SmallModal
          style={{ width: "400px" }}
          isOpen={alerts2}
          setIsOpen={setAlerts2}
          title={"Alert"}
          children={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginBottom: 10 }}>Please Enter Opening Balance</p>
              <Input
                placeholder={"Opening balance"}
                value={opening_balance}
                type="number"
                onChange={(event) => {
                  const value = event.target.value;
                  setOpening_balance(value);
                }}
              />
            </div>
          }
          bname={"Update"}
          onClick={() => handleUpdateBalance()}
        />
      )}
      {alerts && (
        <SmallModal
          isOpen={alerts}
          setIsOpen={setAlerts}
          title={"Alert"}
          mess={alertsMess}
          okbtn={setAlertsMess}
        />
      )}
    </div>
  );
};

export default ProAndLoss;
